import { useEffect, useState } from "react";
import { UserProvider } from "../Entities/UserProvider";
import userProvidersService from "../Service/user-providers.service";

const useUserProvider = () => {
  const [userProvider, setUserProvider] = useState<UserProvider | null>(null);
  const fetchUserProvider = async () => {
    const userProviderData = await userProvidersService.getProviders();
    setUserProvider(userProviderData);
  };

  useEffect(() => {
    fetchUserProvider();
  }, []);

  return {
    userProvider: userProvider,
  };
};

export default useUserProvider;
